export default __webpack_public_path__ + "static/media/91_mobile.d085219a.jpg";